import { checkPermission } from '@/router/guards.ts'

const NotificationModule = () => import('./NotificationModule.vue')
const NotificationIndex = () => import('./views/NotificationIndex.vue')

export const notificationRoute = {
  path: '/notifications',
  name: 'notification',
  component: NotificationModule,
  meta: {
    title: 'Notifications',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'notifications-index',
      component: NotificationIndex,
      meta: {
        permission: 'notification.view',
      },
      beforeEnter: checkPermission('notification.view'),
    },
  ],
}
